import React from "react";
import { Box, Paper, Skeleton, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import { Token } from "../../theme";
import { WEEKDAYS } from "./WorklogCalendar";

export const WORKLOG_SKELETON_ROWS = 10;
const TABLE_SKELETON_COLUMNS = 6;
const CALENDAR_SKELETON_CELLS = 35;

/** Placeholder with the footprint of the work logs table. */
export const WorklogTableSkeleton: React.FC = () => (
  <TableContainer component={Paper} data-testid="worklog-table-skeleton">
    <Table size="small">
      <TableHead>
        <TableRow>
          {Array.from({ length: TABLE_SKELETON_COLUMNS }).map((_, index) => (
            <TableCell key={index}>
              <Skeleton variant="text" width="50%" />
            </TableCell>
          ))}
        </TableRow>
      </TableHead>
      <TableBody>
        {Array.from({ length: WORKLOG_SKELETON_ROWS }).map((_, rowIndex) => (
          <TableRow key={rowIndex}>
            {Array.from({ length: TABLE_SKELETON_COLUMNS }).map((_, columnIndex) => (
              <TableCell key={columnIndex}>
                <Skeleton variant="text" width={columnIndex === 0 ? "60%" : "80%"} />
              </TableCell>
            ))}
          </TableRow>
        ))}
      </TableBody>
    </Table>
  </TableContainer>
);

/** Placeholder with the footprint of WorklogCalendar. */
export const WorklogCalendarSkeleton: React.FC = () => (
  <Box
    data-testid="worklog-calendar-skeleton"
    style={{ background: Token.surfaceCard, border: `1px solid ${Token.borderDefault}`, borderRadius: 8, padding: 12 }}
  >
    <Box style={{ display: "grid", gridTemplateColumns: "repeat(7, minmax(0, 1fr))" }}>
      {WEEKDAYS.map((day) => (
        <div
          key={day}
          style={{
            fontSize: 10.5,
            textTransform: "uppercase",
            letterSpacing: ".08em",
            color: Token.textTertiary,
            fontWeight: 600,
            padding: "0 4px 6px",
          }}
        >
          {day}
        </div>
      ))}
    </Box>
    <Box style={{ display: "grid", gridTemplateColumns: "repeat(7, minmax(0, 1fr))", gap: 6 }}>
      {Array.from({ length: CALENDAR_SKELETON_CELLS }).map((_, index) => (
        <Skeleton key={index} variant="rounded" height={78} />
      ))}
    </Box>
  </Box>
);
